'use strict';
var fails = require('../internals/fails');
var $Object = Object;
var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;

var NATIVE_BIND = !fails(function() {
  var test = function() {}.bind();
  return typeof test !== 'function' || test.hasOwnProperty('prototype');
});

var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

var uncurryThis = NATIVE_BIND ? uncurryThisWithBind : function(fn) {
  return function() {
    return call.apply(fn, arguments);
  };
};

var split = uncurryThis(''.split);
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

var classof = function(it) {
  return stringSlice(toString(it), 8, -1);
};

/**
 * 转索引对象
 * @param {any} it 任意数据
 */
module.exports = fails(function() {
  return !$Object('z').propertyIsEnumerable(0);
}) ? function(it) {
    return classof(it) === 'String' ? split(it, '') : $Object(it);
  } : $Object;
